module.exports = __webpack_public_path__ + "img/arrow.16d5acd4.svg";